import React, { createContext, useContext, useEffect } from 'react'
import type { DisplayWindowPlatform, DisplayWindowPlatformContext } from './types'

const DisplayWindowPlatformContext = createContext<DisplayWindowPlatformContext | null>(null)

interface DisplayWindowPlatformProviderProps {
	platform: DisplayWindowPlatform;
	children: React.ReactNode;
}

export const DisplayWindowPlatformProvider: React.FC<DisplayWindowPlatformProviderProps> = ({ platform, children }) => {
	useEffect(() => {
		// Cleanup on unmount
		return () => {
			platform.cleanup()
		}
	}, [platform])

	return (
		<DisplayWindowPlatformContext.Provider value={{ platform }}>
			{children}
		</DisplayWindowPlatformContext.Provider>
	)
}

export const useDisplayWindowPlatform = (): DisplayWindowPlatform => {
	const context = useContext(DisplayWindowPlatformContext)
	if (!context) {
		throw new Error('useDisplayWindowPlatform must be used within a DisplayWindowPlatformProvider')
	}
	return context.platform
}
